// extracted by mini-css-extract-plugin
export default {"bodyHeading":"post-reg-item-add-modal__bodyHeading__vJOf8","bodyItem":"post-reg-item-add-modal__bodyItem__X2GpO"};